import Vue from 'vue'
import getEnvVars from '@/common/utils/getEnvVars'
const { API_HOST, VERSION, NODE_ENV, ENV } = getEnvVars()

Vue.config.productionTip = NODE_ENV !== 'development'

export default function main() {
  console.log({ VERSION })
  console.log({ ENV })
  console.log({ API_HOST })
}
